module.exports = __webpack_public_path__ + "assets/img/9dbae506ea51fb98dae83c9d653d25ef.svg";